'use client';

import React, { useEffect, useRef } from 'react';
import { atom, useAtom, useAtomValue } from 'jotai';
import { createPortal } from 'react-dom';

export const resourceHeaderTargetAtom = atom<HTMLElement | null>(null);

export function ResourceHeaderTarget(props: React.HTMLAttributes<HTMLDivElement>) {
  const ref = useRef<HTMLDivElement | null>(null);
  // Some consumers infer this atom as read-only, making the setter type `never`.
  // Cast the atom for the setter to avoid cross-package type mismatch.
  const [, _setTarget] = useAtom(resourceHeaderTargetAtom as any);
  const setTarget = _setTarget as unknown as (value: HTMLElement | null) => void;

  useEffect(() => {
    setTarget(ref.current);
    return () => setTarget(null);
  }, [setTarget]);

  return <div {...props} ref={ref} />;
}

export function ResourceHeaderOutlet({ children }: { children: React.ReactNode }) {
  const target = useAtomValue(resourceHeaderTargetAtom);
  if (target) {
    return createPortal(children, target);
  }
  return <>{children}</>;
}
